import { useEffect } from "react";
import { track } from "@src/utils/segment";

interface Props {
  inquiryId: string;
  onComplete: Function;
}

export function PersonaDocumentCapture({ inquiryId, onComplete }: Props) {
  useEffect(() => {
    import("persona").then(module => {
      const personaParams = {
        inquiryId,
        onLoad: () => {
          track("Scan ID On Load Persona Callback");
          client.open();
        },
        onComplete: ({ status }: { status: string }) => {
          if (status === "failed") {
            track("Scan ID On Fail Persona Callback");
            onComplete("fail");
          } else {
            track("Scan ID On Completed Persona Callback");
            onComplete();
          }
        },
        onCancel: () => {
          track("Scan ID On Cancel Persona Callback");
          onComplete("exit");
        },
        onError: () => {
          track("Scan ID On Error Persona Callback");
        },
      };

      const client = new module.Client(personaParams);
    });
  }, [inquiryId, onComplete]);

  return null;
}
